"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.encryptSession = exports.decryptSession = void 0;
require("core-js/modules/es.promise.js");
require("core-js/modules/es.regexp.to-string.js");
var _Config = require("./Config");
var CryptoJS = require("crypto-js");
/**
 * Encrypt Decrypt Session Function
 * @param {String} data 
 * @param {string} process 
 * @returns String
 */
const encryptSession = async data => {
  return await CryptoJS.AES.encrypt(data, _Config.secKey).toString();
};
exports.encryptSession = encryptSession;
const decryptSession = async data => {
  var bytes = CryptoJS.AES.decrypt(data, _Config.secKey);
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
exports.decryptSession = decryptSession;